export default __webpack_public_path__ + "static/GeneralGrotesqueMono-Book-6a5fda875452fabc82004fb864ede068.woff2";